import styled from 'styled-components';

export const Wrapper = styled.div`
    form.formulario-datos-personales span {
        font-size: 0.7rem;
    }
    ._-gQdp {
        margin-bottom: 7px !important;
    }
    ._3kii5 input{
        line-height: 29px;
        height: inherit;
    }
    .Autocomplete-selector .Autocomplete-list li{
        font-size: 0.8rem;
        color: #383838;
    }
    div#cargo-selector input {
        border-radius: 28px;
        font-size: 0.8rem;
    }
    div#pais-selector input {
        border-radius: 28px;
        font-size: 0.8rem;
      }
    div#pais-selector label {
        margin-bottom: 3px;
    }
    form ._2lUSM {
      margin-bottom:15px;
      
    }  

    .label-text h6{
        font-size: 0.8rem !important;
        color: #383838;
    }

    .label-text h6, .label, .Autocomplete-selector label {
        font-size: 0.8rem;
        color: #383838;
    }
    #pais-selector label {
        font-weight: bolder;
        color: #383838;
    }

    .nombre-bloqueado input{
        background-color: #F6F6F6;
        font-size: 0.8rem;
        border-color: #646569;
        text-transform: capitalize;
    }


    form ._2MggJ {
        margin-bottom: 15px;
    }


    .formulario-datos-laborales {
        display: grid;
        gap: 16px;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 100px;
    }

    .label-radio {
        display: grid;
        grid-template-columns: 1fr 1fr;
        width: 80%;
        padding-bottom: 16px;
    }
    .label-radio p {
        font-size: 0.9rem;
        font-weight: 500;
    }
    .Autocomplete-selector label {
        font-weight: bold;
    }
    p.datos-radio {
        font-size: 1rem;
        font-weight: bold;
        color: #383838;
        line-height: 20px;
        margin-bottom: 16px;
    }
    ._1oqQj:hover:after {
        background-color: transparent;
    }
    .contenido.off div {
        opacity: 0.6;
    }
    .contenido .of  .label-radio{
        opacity: 0.6;
    }
    .contenido.off {
        background-color: #c1c1c10f;
        pointer-events: none;
    }
    .contenido.off p.datos-radio {
        opacity: 0.5;
    }
    
    .none-label{
        display:none;
    }

    ._3ZeLa {
        width: 100%;
        margin-bottom: 15px;
    }

    fieldset {
        display: flex;
    }
    .header_datos_personales{
        margin-bottom: 15px;
    }
    legend {
        font-weight: bold;
        font-size: 16px;
 
        margin-bottom: 8px;
        display: block;
    }
    ._3sTov{
        margin-bottom: 15px;

    ._3g_Jc ._10WAf ._3NSXd {
        font-weight: 100;
        font-size: 0.875rem;

    }
    h6, .h6 {
        margin-bottom: 10px;
        font-size: 16px;
    }
    fieldset {
        margin-bottom: 10px;
    }


    .label ._1F3qg, .label ._3IoKh span {
        font-size: 0.7rem;
        margin-top: 5px;
    }


    @media (max-width: 480px){
        .formulario-datos-laborales{
            grid-template-columns: 1fr;
            grid-template-rows: 65px;
        }
        .Autocomplete-selector_mobile .Autocomplete-list{
            top: 66px;
        }
        p.datos-radio {
            font-size: 0.9rem;
            
        }
        .label-radio {
            grid-template-columns: 1fr;
            width: 100%;
        }
        .label-radio p {
            font-size: 0.8rem;
            right: 10px;
            position: relative;
        }
        ._1oqQj {
            right: 10px;
        }
        ._3kii5 input {
            font-size: 0.7rem;
        }
        .Autocomplete-selector input {
            height: 44px;
        }
        .formulario-datos-personales .Autocomplete-selector{
            padding-top: 15px;
        }
        .Autocomplete-selector label {
            font-size: 0.8rem;
        }
        ._3SDeG ._1ZRzS ._3k3jO{
            line-height: inherit;
            height: 38px;
            font-size: 0.7rem;
        }
        form.formulario-datos-laborales.editar-row{
            grid-template-rows: 85px
        }
        ._1F3qg {
            font-size: 0.8rem;
        }
        .solo-responsive{
            // top: 10px;
            // position: relative;
        }
        .Autocomplete-input-wrapper input {
            font-size: 0.8rem;
        }
        .label.tooltip-div {
            margin-top: 10px;
        }
        div#cargo-selector input {
            font-size: 0.7rem;
        }
        ._3kii5 input {
            line-height: 20px;
        }
    }
    @media (max-width: 375px){
        .formulario-datos-laborales{
            grid-template-columns: 1fr;
            grid-template-rows: 65px;
        }
        .Autocomplete-selector_mobile .Autocomplete-list{
            top: 66px;
        }
        ._3kii5 input {
            line-height: 20px;
        }
        .label.tooltip-div {
            margin-top: 10px;
        }
        p.datos-radio {
            font-size: 0.7rem;
            
        }
        .label-radio {
            grid-template-columns: 1fr;
            width: 100%;
        }
        .label-radio p {
            font-size: 0.7rem;
            right: 10px;
            position: relative;
        }
        ._1oqQj {
            right: 10px;
        }
        ._3kii5 input {
            font-size: 0.7rem;
        }
        .Autocomplete-selector input {
            height: 40px;
        }
        .formulario-datos-personales .Autocomplete-selector{
            padding-top: 15px;
        }
        .Autocomplete-selector label {
            font-size: 0.7rem;
        }
        ._3SDeG ._1ZRzS ._3k3jO{
            line-height: inherit;
            height: 38px;
            font-size: 0.7rem;
        }
        form.formulario-datos-laborales.editar-row{
            grid-template-rows: 85px
        }
        ._1F3qg {
            font-size: 0.7rem;
        }
        .solo-responsive{
            // top: 10px;
            // position: relative;
        }
        .Autocomplete-input-wrapper input {
            font-size: 0.8rem;
        }
        div#cargo-selector input {
            font-size: 0.7rem;
        }
    }

    @media (max-width: 320px){
        form imput{
            font-size:1.2rem
        }
        ._3kii5 input {
            line-height: 20px;
        }
        .label.tooltip-div {
            margin-top: 10px;
        }
        card{
            margin-right: auto;
            margin-left: auto;
        }
        .formulario-datos-personales {
            display: grid;
            grid-template-columns: 1fr;
            grid-template-rows: 54px;
            gap: 26px;
        }
        .label-text h6 {
            font-size: 0.7rem;
        }
        .Autocomplete-selector_mobile .Autocomplete-list{
            top: 66px;
        }
        .label span {
            font-size: 0.7rem;
        }
        form ._2lUSM{
            margin-bottom: 0px;
        }
        ._3g_Jc p {
            font-size: 0.7rem;
        }
        .formulario-datos-laborales{
            grid-template-columns: 1fr;
            grid-template-rows: 56px;
        }
        p.datos-radio {
            font-size: 0.8rem;
            
        }
        .label-radio {
            grid-template-columns: 1fr;
            width: 100%;
        }
        .label-radio p {
            font-size: 0.7rem;
            right: 10px;
            position: relative;
        }
        ._1oqQj {
            right: 10px;
        }
        
       .formulario-datos-personales .Autocomplete-selector{
            padding-top: 15px;
        }
        ._3kii5 input {
            font-size: 0.7rem;
        }
        .Autocomplete-selector input {
            height: 40px;
        }
        .Autocomplete-selector label {
            font-size: 0.7rem;
        }

        ._3SDeG ._1ZRzS ._3k3jO{
            line-height: inherit;
            height: 38px;
        }

        form.formulario-datos-laborales.editar-row{
            grid-template-rows: 85px
        }
        ._1F3qg {
            font-size: 0.7rem;
        }
        .solo-responsive{
            // top: 10px;
        // position: relative;
        }
        
        .Autocomplete-input-wrapper input {
            font-size: 0.7rem;
        }
        div#cargo-selector input {
            font-size: 0.7rem;
        }
        
    }
   
`;

export default Wrapper;